<script setup lang="ts">
import { ref, useSlots } from "vue";
defineProps<{
  title?: string;
  open?: () => void;
  state?: boolean;
}>();

const slots = useSlots();
const custom = ref(!!slots.default);
</script>

<template>
  <div class="dropdown-trigger" :style="!custom ? { height: '24px' } : ''" @click="open">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.dropdown-trigger {
  overflow: hidden;

  img {
    height: 24px;
    cursor: pointer;
    transform: rotate(90deg);
  }
}
</style>
